import colors from '@/config/colors';
import { StyleSheet } from 'react-native';
import theme from '@/config/theme';
import { IS_WEB } from '@/utils/platform';

export const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'visible',
  },
  modal: {
    backgroundColor: colors.white,
    borderRadius: 8,
    padding: 64,
    width: '100%',
    maxHeight: '95%',
    minHeight: 200,
  },
  containerWide: {
    padding: theme.spacings.lg,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'visible',
  },
  modalWide: {
    padding: theme.spacings.lg,
    height: '95%',
    minHeight: IS_WEB ? 400 : undefined,
  },
  contentWide: {
    flex: 1,
    width: '100%',
  },
  closeButton: {
    position: 'absolute',
    top: 24,
    right: 24,
  },
  title: {
    fontWeight: 600,
    fontSize: 20,
    marginBottom: 16,
    fontFamily: 'InterSemiBold',
  },
  singleActionButton: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 20,
  },
  actionButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    gap: 20,
  },
});
